<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white">
            <h3 style="text-align: center">ใบกำกับภาษีขาย</h3>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">เลขที่ใบกำกับภาษี</label>
                        <div class="col-sm-8">
                            <masked-input v-model="form.tax_invoice"
                                          mask="V111111111"
                                          placeholder="เลขใบกำกับภาษี"
                                          class="form-control"
                                          type="tel"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">วันที่</label>
                        <div class="col-sm-8">
                            <date-picker :lang="lang"
                                         v-model="form.date"
                                         placeholder="วันที่ต้องการพิมพ์"
                                         class="w-100"
                                         :format="changeFormat" confirm>
                            </date-picker>
                        </div>
                    </div>
                </div>
            </div>
            <span style="padding-left: 20px; color: red">**หากไม่ค้นพบ TN ที่ต้องการสร้าง V  แสดงว่า TN นั้นถูกสร้างใบกำกับภาษีไปแล้ว</span>
            <div class="table-responsive" style="min-height: 300px">
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th scope="col">วันที่ TN</th>
                        <th>หมายเลข TN</th>
                        <th>ลูกค้า</th>
                        <th>มูลค่าสินค้า</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            {{ form.invoice ? form.invoice.date : '' | moment('DD/MM/YYYY') }}
                        </td>
                        <td>
                            <multiselect
                                @input="calculateTax"
                                v-model="form.invoice"
                                :options="optionsInvoices"
                                label="invoice_id"
                                placeholder="เลือกรายการ TN"
                                track-by="id">
                            </multiselect>
                        </td>
                        <td>
                            <template v-if="form.invoice">
                                {{ form.invoice.customer ? form.invoice.customer.customer_id : '' }}
                                {{ form.invoice.customer ? form.invoice.customer.store_name : '' }}
                            </template>
                        </td>
                        <td>
                            {{ form.invoice ? form.invoice.total : 0 | currency }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="form-group row total-padding mt-5">
                <div class="col">
                    <span>VAT</span>
                </div>
                <div>
                    <multiselect
                        style="width: 199px;"
                        v-model="TaxVAT"
                        :options="optionsTaxVAT"
                        label="text"
                        placeholder="เลือกรายการ TN"
                        :show-labels="false"
                        :allow-empty="false"
                        track-by="value">
                    </multiselect>
                </div>
            </div>
            <div class="form-group row total-padding">
                <div class="col">
                    <span>มูลค้าสินค้ารวม</span>
                </div>
                <div>
                    <input class="form-control" v-model="form.total"/>
                </div>
            </div>
            <div class="form-group row total-padding">
                <div class="col">
                    <span>จำนวนเงินภาษีมูลค่าเพิ่ม (TAX)</span>
                </div>
                <div>
                    <input class="form-control" v-model="calculateVAT"/>
                </div>
            </div>
            <div class="col text-center mt-3">
                <button type="button" class="btn btn-success" @click="saveTaxInvoice">
                    <icon name="save"></icon>
                    บันทึก
                </button>
                &nbsp;&nbsp;
                <button type="button"
                        @click="cancelTaxInvoice"
                        class="btn btn-outline-secondary">
                    <icon name="times"></icon>
                    ยกเลิก
                </button>
            </div>
        </div>
        <b-modal hide-footer hide-header ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import VuePagination from "../../Pagination";
import moment from "moment";
import DatePicker from 'vue2-datepicker'
import Loading from "../../Utility/Loading";
import MaskedInput from 'vue-masked-input'

export default {
    name: "tax-invoice-form",
    components: {
        Loading,
        Multiselect,
        VuePagination,
        DatePicker,
        MaskedInput,
    },
    data() {
        return {
            msg: '',
            status_loading: 1,
            items: [
                {
                    text: "รายการใบกำกับภาษีขาย",
                    to: {name: "tax-invoice-list"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            optionsInvoices: [],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            TaxVAT: {value: 1, text: 'VAT ใน'},
            optionsTaxVAT: [
                {value: 1, text: 'VAT ใน'},
                {value: 2, text: 'VAT นอก'},
            ],
        }
    },
    created() {
        this.getInvoicesTax();
    },
    computed: {
        ...mapState({
            form: state => {
                return state.TaxInvoice.form
            },
        }),
        calculateVAT() {
            if (this.TaxVAT.value == 1) {
                if (this.form.invoice) {
                    this.form.total = parseFloat(this.form.invoice.total).toFixed(2);
                }
                this.form.tax = this.form.total * (7 / 107)
                this.form.tax = this.form.tax.toFixed(2);
            } else {
                if (this.form.invoice) {
                    this.form.total = parseFloat(this.form.invoice.total).toFixed(2);
                }
                this.form.tax = this.form.total * 0.07;
                this.form.tax = this.form.tax.toFixed(2);
            }
            return this.form.tax;
        }
    },
    methods: {

        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        showLoadingModal(id) {
            this.$refs.loading.show();
        },
        getInvoicesTax() {
            this.$store.dispatch("TaxInvoice/getInvoiceByStatusTax").then(invoice => {
                this.optionsInvoices = invoice;
            });
        },
        saveTaxInvoice() {
            if (!this.form.date) {
                alert('กรุณาเลือกวันที่')
            } else if (!this.form.invoice) {
                alert('กรุณาเลือก TN ที่ต้องการสร้างภาษี')
            } else {
                let data = {
                    date: moment(this.form.date).format('YYYY-MM-DD'),
                    invoice_id: this.form.invoice.id,
                    total: this.form.total,
                    tax: this.form.tax,
                    tax_invoice: this.form.tax_invoice,
                    VAT: this.TaxVAT.value
                };
                this.showLoadingModal();
                this.msg = 'กำลังบันทึก กรุณารอสักครู่';
                this.status_loading = 1;
                this.$store.dispatch("TaxInvoice/saveTaxInvoice", {
                    id: this.form.id,
                    data: data,
                }).then(res => {
                    this.hideLoadingModal();
                    if (res) {
                        // this.goToTaxInvoiceList();
                        window.close();
                    } else {
                        alert('เลข V ซ้ำกรุณาลองใหม่อีกครั้ง');
                    }
                }).catch(() => {
                    this.showLoadingModal();
                    this.msg = 'บันทึกข้อมูลไม่สำเร็จ';
                    this.status_loading = 3;
                })
            }
        },
        cancelTaxInvoice() {
            // this.goToTaxInvoiceList();
            window.close();
        },
        calculateTax() {
            if (this.form.invoice) {
                this.form.total = parseFloat(this.form.invoice.total).toFixed(2);
            }
            this.form.tax = this.form.total * (7 / 107)
            this.form.tax = this.form.tax.toFixed(2);
        },
        goToTaxInvoiceList() {
            this.$router.push("/accounting/tax-invoice");
        }
    }
}
</script>

<style scoped>
thead {
    background-color: lightgray;
    color: black;
}

tbody {
    background-color: white;
    color: black;
}

.total-padding {
    padding-right: 20px;
    text-align: right;
}
</style>
